export default "__VITE_ASSET__D1BCA$W0__"